import React, { PureComponent } from "react";
import WidgetLayout from "../shared/WidgetLayout";
import OfferTypeSwitcherContainer from "../../../../../containers/OfferTypeSwitcherContainer";
import styled from "styled-components";
import { cssMainSelector } from "../../../../../lib/cssSelectors";
import { showMultipleOfferTypes } from "../../../../../lib/clientConfig";

const Container = styled.div``;

const OfferTypeSwitchWrapper = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    padding-bottom: ${p => p.theme.spacing.lg};
  }
`;

class Widget extends PureComponent {
  render() {
    const {
      clientConfig,
      offerType,
      portal,
      selectedEntity,
      sponsoredPositionCount,
      updateExperiment,
      updateModal,
      widgetOptions
    } = this.props;

    return (
      <Container>
        {showMultipleOfferTypes(clientConfig) && (
          <OfferTypeSwitchWrapper>
            <OfferTypeSwitcherContainer />
          </OfferTypeSwitchWrapper>
        )}
        <WidgetLayout
          clientConfig={clientConfig}
          offerType={offerType}
          portal={portal}
          selectedEntity={selectedEntity}
          sponsoredPositionCount={sponsoredPositionCount}
          updateExperiment={updateExperiment}
          updateModal={updateModal}
          widgetOptions={widgetOptions}
        />
      </Container>
    );
  }
}

export default Widget;
